<template>
	<div id="knowledge">
		<div class="banner">
			<img :src="pageData.article_topbanner" class="pic">
		</div>
		<breadcrumb/>
		<div class="widthBox">
			<div class="search">
				<h3>新闻资讯</h3>
				<label class="searchBox acea-row row-middle">
					<input v-model="keyword" type="text" />
					<i @click="searchChange" class="iconfont icon-sousuo"></i>
				</label>
				<div class="hot">
					<template v-for="(item,index) in pageData.hotsearchtitle">
						<template v-if="index > 0">|</template>
						<span @click="searchChange" :data-keyword="item.title">
							{{item.title}}
						</span>
					</template>
					
				</div>
			</div>
			<div class="news">
				<pageTitle en="ADVANTAGE" title="行业动态" />
				<ul class="list acea-row row-between">
					<li @click="toDetail(item.id)" @mouseover="industryHover(index)" :class="industryIndex==index?'active':''" v-for="(item,index) in pageData.industry_list">
						<div class="pic">
							<img :src="item.main_figure" alt="">
						</div>
						<div class="txt">
							<div class="time">
								<span>{{item.date}}</span>
								<span>{{item.catename}}</span>
							</div>
							<p>{{item.title}}</p>
							<p class="text">{{item.describe}}</p>
						</div>
					</li>
				</ul>
				<router-link style="display: block;" to="/dynamic" class="more">立即查看</router-link>
			</div>
			<div class="knowlBox">
				<pageTitle en="ADVANTAGE" title="科普知识" />
				<ul class="list acea-row">
					<li @click="toDetail(item.id)" v-for="item in articlelist">
						<img :src="item.main_figure" alt="">
						<div class="txt">
							<h4>{{item.title}}</h4>
							<div class="date">{{item.date}}</div>
							<div class="more">查看详情</div>
						</div>
					</li>
				</ul>
				<pagination @getPage="getPage" :current-page="1" :page-size="6" :total="total" />
			</div>
		</div>
	</div>
</template>

<script>
	import breadcrumb from '@/components/breadcrumb.vue'
	import pageTitle from '@/components/pageTitle.vue'
	import pagination from '@/components/pagination.vue'
import metaInfo from "@/utils/metaInfo.js";
export default {
	metaInfo,
	  name: 'knowledge',
	  components: { breadcrumb,pageTitle,pagination },
	  data:function(){
	  	  return{
			  pageData:{},
			  page:1,
			  keyword:'',
			  articlelist:[],
			  total:0,
			  industryIndex:0
	  	  }
	  },
	  created() {
		  this.getData()
	  },
	  methods:{
		  searchChange(e){
			  var keyword = e.currentTarget.dataset.keyword
			  if(keyword){
				  this.keyword=keyword
			  }
			  this.$router.push({path:'/dynamic', query:{keyword:this.keyword}});
		  },
		  getPage(e){
			  this.articlelist = []
			  this.page = e
			  this.getData()
		  },
		  toDetail(e){
			  this.$router.push({path:'/detail', query:{id:e}});
		  },
		  getData(){
			this.$api.post('home/Index/articlefir', {
				keyword:this.keyword,
				page:this.page,
			}).then(res => {
				this.pageData = res.data
				this.articlelist = res.data.articlelist
				this.total = res.data.total
			})
		  },
		  industryHover(e){
			  if(this.industryIndex == e) return
			  this.industryIndex = e
		  }
	  },
	}
</script>

<style lang="scss">
	#knowledge{
		.banner{
			img{
				width:100%;
			}
		}
		.search{
			padding:50px 0 0 0;
			h3{
				text-align: center;
				font-size:24px;
				color:#124098;
			}
			.searchBox{
				height: 50px;
				border: 1px solid #dcdbdb;
				border-radius: 100px;
				display: block;
				overflow: hidden;
				margin-top:20px;
				input{
					width:calc(100% - 64px);
					height:50px;
					border:0;
					box-sizing: border-box;
					padding:0 20px;
				}
				.iconfont{
					width:24px;
					height:24px;
					font-size:24px;
					padding:13px 20px;
					vertical-align: middle;
				}
			}
			.hot{
				font-size:18px;
				line-height:24px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				margin-top:17px;
				text-align: center;
				span{
					line-height:24px;
					font-size:16px;
					display: inline-block;
					width:230px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					margin:0 14px;
					vertical-align: middle;
					cursor: pointer;
					.iconfont{
						width:24px;
						font-size:24px;
						color:#124098;
						height:24px;
						vertical-align: middle;
					}
				}
			}
		}
		
		.news{
			padding:60px 0;
			.list{
				margin-top:34px;
				li{
					width:23.5%;
					position: relative;
					transition: 0.3s;
					cursor: pointer;
					&.active{
						width:48%;
						.txt{
							p.text{
								display: block;
							}
						}
					}
					.pic{
						height:320px;
						width:100%;
						overflow: hidden;
						img{
							min-width:100%;
							min-height:100%;
						}
					}
					.txt{
						position: absolute;
						left:0;
						top:0;
						width:100%;
						height:100%;
						box-sizing: border-box;
						padding:40px 30px;
						color:#FFF;
						background:rgba($color: #000000, $alpha: 0.2);
						.time{
							font-size:14px;
							span{
								margin-right:10px;
							}
						}
						p{
							margin-top:10px;
						}
						p.text{
							margin-top:16px;
							display: none;
						}
					}
				}
			}
			.more{
				width:135px;
				line-height:38px;
				color:#FFF;
				background:#124098;
				font-size:14px;
				text-align: center;
				margin:40px auto 0;
			}
		}
		
		.knowlBox{
			padding:0 0 30px;
			.list{
				margin-top:40px;
				li{
					width:calc(100% /3 - 30px);
					margin-right:45px;
					border-bottom: 1px solid #dfdfdf;
					cursor: pointer;
					margin-bottom:40px;
					&:nth-child(3n){
						margin-right:0;
					}
					&:hover{
						border-color:#124098;
					}
					img{
						width:100%;
					}
					.txt{
						padding:24px 0;
						h4{
							font-size:18px;
							line-height:26px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							color:#333;
						}
						.date{
							line-height:22px;
							font-size:16px;
							margin-top:16px;
						}
						.more{
							color:#333;
							font-size:16px;
							line-height:24px;
							margin-top:20px;
						}
					}
				}
			}
		}
	}
	@media screen and(max-width:768px) {
		#knowledge{
			.search{
				padding-top:20px;
				.h3{
					text-align: center;
					color:#124098;
					font-size:16px;
					line-height:32px;
				}
				.searchBox{
					 box-sizing: border-box;
					 margin:10px 0px 0;
					 height:40px;
					 .iconfont{
						 padding:8px 15px;
						 line-height:40px;
					 }
					input{
						height:40px;
					}
				}
				.hot{
					 margin:10px 0px 0;
					 span{
						 font-size:14px;
						 margin:5px;
					 }
				}
			}
			.news{
				padding:20px 0 30px;
				 .list{
					 margin-top:20px;
					 li{
						 padding:0;
						 width:100%;
						 position: relative;
						 margin:20px 0px 0;
						 position: relative;
						 &:first-child{
							 margin-top:0;
						 }
						 &.active{
							 width:100%;
						 }
						 .pic{
							 width:100%;
							 height:auto;
							 img{
								 vertical-align: middle;
							 }
						 }
						.txt{
							padding:20px;
						}
						.time{
							font-size:16px;
						}
						h4{
							font-size:16px;
						}
						p{
							font-size:14px;
							margin-top:0;
						}
					 }
				 }
				 .more{
					 margin-top:20px;
				 }
			}
			
			.knowlBox{
				.list{
					margin-top:20px;
					li{
						width:calc(50% - 5px);
						margin-right:0;
						margin-bottom:20px;
						&:nth-child(even){
							margin-left:10px;
						}
						.txt{
							padding:10px 0;
							h4{
								font-size:16px;
							}
							.date{
								margin-top:5px;
								font-size:12px;
								color:#999;
							}
							.more{
								margin-top:5px;
								color:#124098;
								font-size:12px;
							}
						}
					}
				}
			}
		}
	}
</style>
